import { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

const faqs: FaqItem[] = [
  {
    q: '嫩草视频需要注册登录才能观看吗？',
    a: '不需要。嫩草视频全站内容均无需注册登录即可直接观看，打开网站就能开始你的观影之旅。我们始终坚持以最便捷的方式为用户提供高清影视资源。',
  },
  {
    q: '平台上的视频画质如何？会不会卡顿？',
    a: '嫩草视频主打1080P超清画质，部分内容支持4K。我们采用多线路智能调度技术，自动为用户匹配最优CDN节点，确保播放流畅不卡顿。如果遇到缓冲，可尝试切换播放线路。',
  },
  {
    q: '平台内容更新频率是怎样的？',
    a: '平台内容每日同步更新。热门剧集和综艺上线后，通常在当天即可在嫩草视频上找到更新资源。电影、动漫和纪录片也会根据片源情况第一时间更新。',
  },
  {
    q: '移动端可以正常使用吗？需要下载App吗？',
    a: '完全不需要下载App。嫩草视频已完美适配手机浏览器和平板设备，只需在Safari或Chrome中打开网站即可流畅观影。自适应画质技术会根据你的网络和设备自动调整最佳播放效果。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
            答疑解惑
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            快速了解嫩草视频的使用方式
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={faq.q}
              className="bg-background-50 rounded-2xl border border-background-200/80 overflow-hidden transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {faq.q}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-100 flex-shrink-0 transition-transform duration-200"
                  style={{ transform: openIndex === i ? 'rotate(45deg)' : 'rotate(0deg)' }}
                >
                  <i className="ri-add-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === i ? 'max-h-96 pb-5 md:pb-6 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}